export enum TimelineGridEventRowDataAttributes {
  /**
   * The ID of the resource for this event row.
   */
  resourceId = 'data-resource-id',
  /**
   * Present when event creation is disabled.
   */
  creationDisabled = 'data-creation-disabled',
}
